




































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';

@Component({
  components: {
    SwScrollView,
  },
})
export default class GenericScrollView extends SwExtendedVue {
  navBarTravelling: boolean = false;
  navBarTravelDirection: string = '';
  navBarTravelDistance: number = 200;
  overflow : string = 'none';
  scrollNav: HTMLElement | null;
  scrollNavContents: HTMLElement | null;
  leftVisibility: boolean = true;
  rightVisibility: boolean = true;
  rightDiff: Number;
  leftDiff: Number;
  containerMetrics: any;
  containerMetricsRight: any;
  containerMetricsLeft: any;
  scrollEvent: any;

  @Watch('scrollEvent', { deep: true })
  private con() {
  }
  @Watch('nocards')
  private noCardsFound() {
    if (this.nocards) {
      this.rightDiff = 0;
    }
  }

  @Prop()
  nocards:boolean;

  @Prop()
  scrollheight:any;

  mounted() {
    this.rightDiff = 0;
    this.leftDiff = 0;
    this.scrollNav = document.getElementById('genericScrollNav')!;
    this.scrollNavContents = document.getElementById('genericScrollNavContents');
    this.scrollNav.style.height = `${this.scrollheight}`;
    this.$nextTick(() => {
      window.addEventListener('resize', this.determineOverflow);
    });

    this.determineOverflow();
    this.scrollEvent = this.scrollNav!.scrollLeft;

    this.scrollNav!.addEventListener('scroll', (e: Event) => { // tslint:disable-line
      this.determineOverflow();
    });
     // tslint:disable-next-line:no-console
    // console.log('after set rightdiff: ', this.rightDiff);
  }

  scrollLeft() {
    if (this.navBarTravelling) {
      return;
    }
  //  this.scrollNav!.setAttribute('data-overflowing', this.determineOverflow());
    if (this.determineOverflow() === 'left' || this.overflow === 'both') {
      const availableScrollLeft = this.scrollNav!.scrollLeft;
      if (availableScrollLeft < this.navBarTravelDistance * 2) {
        this.scrollNavContents!.style.transform = `translateX(${availableScrollLeft}px)`;
      } else {
        this.scrollNavContents!.style.transform = `translateX(${this.navBarTravelDistance}px)`;
      }
      this.scrollNavContents!.classList.remove('noTransition');
      this.navBarTravelling  = true;
      this.navBarTravelDirection = 'left';
    }
   // this.scrollNav!.setAttribute('data-overflowing', this.determineOverflow());
  }
  scrollRight() {
    if (this.navBarTravelling) {
      return;
    }
   // this.scrollNav!.setAttribute('data-overflowing', this.determineOverflow());
    if (this.determineOverflow() === 'right' || this.overflow === 'both') {
      const navBarRightEdge = this.scrollNavContents!.getBoundingClientRect().right;
      const navBarScrollerRightEdge = this.scrollNav!.getBoundingClientRect().right;
      const availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
      if (availableScrollRight < this.navBarTravelDistance * 2) {
        this.scrollNavContents!.style.transform = `translateX(-${availableScrollRight}px)`;
      } else {
        this.scrollNavContents!.style.transform = `translateX(-${this.navBarTravelDistance}px)`;
      }
      this.scrollNavContents!.classList.remove('noTransition');
      this.navBarTravelDirection = 'right';
      this.navBarTravelling  = true;
    }
  //  this.scrollNav!.setAttribute('data-overflowing', this.determineOverflow());
  }
  determineOverflow() {
    this.rightDiff = 0;
    this.leftDiff = 0;
    this.containerMetrics = this.scrollNav!.getBoundingClientRect();
    this.containerMetricsRight = Math.floor(this.containerMetrics.right);
    this.containerMetricsLeft = Math.floor(this.containerMetrics.left);
    const contentMetrics = this.scrollNavContents!.getBoundingClientRect();
    const contentMetricsRight = Math.floor(contentMetrics.right);
    const contentMetricsLeft = Math.floor(contentMetrics.left);
    this.overflow = 'none';
    if (this.containerMetricsLeft > contentMetricsLeft && this.containerMetricsRight < contentMetricsRight) {
      this.overflow = 'both';
    } else if (contentMetricsLeft < this.containerMetricsLeft) {
      this.overflow = 'left';
    } else if (contentMetricsRight > this.containerMetricsRight) {
      this.overflow = 'right';
    }
    this.rightDiff = contentMetricsRight - this.containerMetricsRight;
    this.leftDiff = contentMetricsLeft - this.containerMetricsLeft;
    return this.overflow;
  }
  transitionEnd() {
    const scrollNav = document.getElementById('genericScrollNav');
    const scrollNavContents = document.getElementById('genericScrollNavContents') ;
    const styleOfTransform = window.getComputedStyle(scrollNavContents as Element, null);
    const tr = styleOfTransform.getPropertyValue('-webkit-transform') || styleOfTransform.getPropertyValue('transform');
    const amount = Math.abs(parseInt(tr.split(',')[4], 10) || 0);
    scrollNavContents!.style.transform = 'none';
    scrollNavContents!.classList.add('noTransition');
    if (this.navBarTravelDirection === 'left') {
      scrollNav!.scrollLeft = scrollNav!.scrollLeft - amount;
    } else {
      scrollNav!.scrollLeft = scrollNav!.scrollLeft + amount;
    }
    this.navBarTravelling  = false;
    this.determineOverflow();
  }
  scrollE() {
    // console.log('Rush:: ', this.scrollNavContents!.scrollLeft, this.scrollNavContents!.scrollWidth, this.scrollNav!.scrollLeft, this.scrollNav!.scrollWidth);
    // this.scrollEvent = this.scrollNav!.scrollLeft;
  }
  created() {
    this.rightDiff = 0;
    this.leftDiff = 0;
  }
}
